/*
 * Copyright 2023 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Annotation for specifying AWS account id
 *
 * @public
 */
export const ANNOTATION_AWS_ACCOUNT_ID: string = 'amazonaws.com/account-id';
/**
 * Annotation for specifying AWS arn
 *
 * @public
 */
export const ANNOTATION_AWS_ARN: string = 'amazonaws.com/arn';
